import React from 'react';

const FilterTabs = ({ filters, currentFilter, onChange }) => {
    return (
        <div style={{
            display: 'flex',
            gap: '10px',
            padding: '10px 0',
            borderBottom: '1px solid #eee'
        }}>
            {filters.map(filter => (
                <button
                    key={filter.id}
                    onClick={() => onChange(filter.id)}
                    style={{
                        padding: '8px 16px',
                        border: 'none',
                        borderRadius: '4px',
                        backgroundColor: currentFilter === filter.id ? '#2D3277' : '#f5f5f5',
                        color: currentFilter === filter.id ? 'white' : '#666',
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}
                >
                    <span>{filter.label}</span>
                    <span style={{
                        backgroundColor: currentFilter === filter.id ? '#1a1b4b' : '#e0e0e0',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '0.8rem'
                    }}>
                        {filter.count}
                    </span>
                </button>
            ))}
        </div>
    );
};

export default FilterTabs;